import React, { useState } from "react";
import "./AddRequestModal.css";
import { useLanguage } from "../../../../LanguageProvider";
import { IoCloseOutline } from "react-icons/io5";
import { TbApi } from "react-icons/tb";
import AddModalInputField from "../../../../components/AddModalInputField/AddModalInputField";
import { useToaster } from "../../../../ToasterProvider";

export default function AddRequestModal({ isOpen, onClose, onCreate }) {
  const { toastWarning } = useToaster();
  const { getTranslation } = useLanguage();
  const [requestTitle, setRequestTitle] = useState("");

  if (!isOpen) return null;

  const handleCreate = () => {
    if (requestTitle.trim() === "") {
      toastWarning(getTranslation("requestNameCantBeEmpty"));
      return;
    }
    onCreate(requestTitle);
    onClose();
    setRequestTitle("");
  };

  return (
    <div className="add-request-modal-overlay">
      <div className="add-request-modal-container">
        <IoCloseOutline
          className="add-request-modal-button close"
          onClick={onClose}
        />

        <p className="add-request-modal-title">{getTranslation("addNewApi")}</p>

        <AddModalInputField icon={<TbApi size={22} style={{ width: "25px" }} />} placeholder={getTranslation("apiName") + "*"} value={requestTitle} onChange={(e) => setRequestTitle(e.target.value)} type={"text"} />

        <div className="add-request-modal-actions">
          <button
            className="add-request-modal-button create"
            onClick={handleCreate}
          >
            {getTranslation("create")}
          </button>
        </div>
      </div>
    </div>
  );
}
